import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { DeepPartial } from 'types/utility';
import { actionCreatorFactory } from 'typescript-fsa';

export const { wrapFetching, wrapSaving, withXhrStatusReducer } =
  createXhrStatusModule('notificationSettings');

export enum NotificationKey {
  archived_client_email = 'archived_client_email',
  archived_client_mobile = 'archived_client_mobile',
  archived_project_email = 'archived_project_email',
  archived_project_mobile = 'archived_project_mobile',
  budget_progress_email = 'budget_progress_email',
  budget_progress_mobile = 'budget_progress_mobile',
  feature_newsletter = 'feature_newsletter',
  have_your_say_email = 'have_your_say_email',
  invite_project_email = 'invite_project_email',
  invite_project_mobile = 'invite_project_mobile',
  new_drafts_mobile = 'new_drafts_mobile',
  timer_plan_reached_mobile = 'timer_plan_reached_mobile',
  timer_running_hour_mobile = 'timer_running_hour_mobile',
  way_around_email = 'way_around_email',
  weekly_stats_email = 'weekly_stats_email',
  assigned_task_email = 'assigned_task_email',
  assigned_task_mobile = 'assigned_task_mobile',
  due_task_email = 'due_task_email',
  due_task_mobile = 'due_task_mobile',
}

export type NotificationSettings = {
  id: number;
} & {
  [_key in keyof typeof NotificationKey]: boolean | null;
};

export enum NotificationDay {
  Monday = 'MO',
  Tuesday = 'TU',
  Wednesday = 'WE',
  Thursday = 'TH',
  Friday = 'FR',
  Saturday = 'SA',
  Sunday = 'SU',
}

export interface NotificationReminders {
  id: number;
  at: string;
  byday: Array<NotificationDay>;
  mobile: boolean;
  email: boolean;
}

export interface State {
  settings: NotificationAndReminderSettings | null;
  draft: NotificationAndReminderSettings | null;
  xhrStatus: XhrStatus;
}

export interface NotificationAndReminderSettings {
  notification_settings: NotificationSettings;
  reminders: NotificationReminders;
}

const actionCreator = actionCreatorFactory('timely/notificationSettings');

export const fetchedNotificationSettings =
  actionCreator<NotificationAndReminderSettings>('FETCHED');
export const startDraft = actionCreator('START_DRAFT');
export const clearDraft = actionCreator('CLEAR_DRAFT');
export const updateDraft =
  actionCreator<DeepPartial<NotificationAndReminderSettings>>('UPDATE_DRAFT');
export const savedDraft = actionCreator<NotificationAndReminderSettings>('SAVED');
